import { render } from "./SolarEclipse2024.vue?vue&type=template&id=7bd395cc&ts=true"
import script from "./SolarEclipse2024.vue?vue&type=script&lang=ts"
export * from "./SolarEclipse2024.vue?vue&type=script&lang=ts"

import "./SolarEclipse2024.vue?vue&type=style&index=0&id=7bd395cc&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__